/**
 * Alpine.js component for the document-template merge fields sidebar.
 * Renders a searchable, grouped list of fields. Clicking a field copies
 * `{{ field.id }}` to the clipboard so the user can paste it into the
 * Tiptap editor (or anywhere else).
 *
 * Usage:
 *   <div x-data="mergeFieldsSidebar(groupsJSON)">…</div>
 *
 * `groups` shape: Array<{ key, label, fields: Array<{ id, label }> }>
 */
function fallbackCopy(text) {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand("copy");
  } catch (_) {
    /* ignore */
  }
  document.body.removeChild(ta);
}

export default function registerMergeFieldsSidebar(Alpine) {
  Alpine.data("mergeFieldsSidebar", function (groups = []) {
    return {
      groups,
      query: "",
      copiedId: null,
      _copyTimer: null,

      get filteredGroups() {
        const q = this.query.trim().toLowerCase();
        if (!q) return this.groups;
        return this.groups
          .map((group) => ({
            ...group,
            fields: group.fields.filter(
              (field) => field.label.toLowerCase().includes(q) || field.id.toLowerCase().includes(q)
            )
          }))
          .filter((group) => group.fields.length > 0);
      },

      copy(id, event) {
        const text = `{{ ${id} }}`;
        const done = () => {
          this.copiedId = id;
          clearTimeout(this._copyTimer);
          this._copyTimer = setTimeout(() => {
            this.copiedId = null;
          }, 1500);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard
            .writeText(text)
            .then(done)
            .catch(() => {
              fallbackCopy(text);
              done();
            });
        } else {
          fallbackCopy(text);
          done();
        }

        event?.currentTarget?.blur();
      }
    };
  });
}
